import { Name as UserLogoutConfirmationEvent } from '@ori-events/user-logout-confirmation';
import { Name as UserLogoutConfirmedEvent } from '@ori-events/user-logout-confirmed';
import type { VFC } from 'react';
import { useCallback, useEffect, useState } from 'react';

import { ConfirmationDialog } from '../ConfirmationDialog/ConfirmationDialog';

const DialogWrapper: VFC = () => {
  const [isActive, setActive] = useState<boolean>(false);

  const handleConfirmation = useCallback(() => {
    window.dispatchEvent(new CustomEvent(UserLogoutConfirmedEvent));
  }, []);

  const handleCancel = useCallback(() => {
    // Timeout to allow for window close animation to finish.
    setTimeout(() => {
      setActive(false);
    }, 1000);
  }, []);

  useEffect(() => {
    window.addEventListener(UserLogoutConfirmationEvent, () => {
      setActive(true);
    });
  }, []);

  return isActive ? (
    <ConfirmationDialog
      onConfirm={handleConfirmation}
      onCancel={handleCancel}
    />
  ) : null;
};

export default DialogWrapper;
